/**
 * Tundra Defender - Cart Count Handler
 * A standalone utility to ensure consistent cart count display across the site
 */

class CartCountHandler {
    constructor() {
        this.initializeCartCount();
        this.setupEventListeners();
    }

    initializeCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                this.updateCartElements(cart.item_count);
            })
            .catch(error => {
                // Handle error silently
            });
    }

    updateCartElements(itemCount) {
        const cartElements = document.querySelectorAll('a[href="/cart"]');

        cartElements.forEach(element => {
            const cartTextElement = element.querySelector('.site-header__cart-text');
            const targetElement = cartTextElement || element;
            const headerCart = element.closest('.site-header__cart');
            const cartLabel = itemCount > 0 ? `Cart (${itemCount})` : 'Cart';

            if (headerCart) {
                headerCart.setAttribute('data-cart-label', cartLabel);
            }

            if (itemCount > 0) {
                // Check if the text already contains a count in parentheses
                if (targetElement.textContent.includes('(')) {
                    // Replace existing count
                    targetElement.textContent = targetElement.textContent.replace(/\(\d+\)/, `(${itemCount})`);
                } else {
                    // Add new count
                    targetElement.textContent = `Cart (${itemCount})`;
                }
            } else {
                // Remove count if cart is empty
                targetElement.textContent = targetElement.textContent.replace(/\s*\(\d+\)/, '');
                if (!targetElement.textContent.toLowerCase().includes('cart')) {
                    targetElement.textContent = 'Cart';
                }
            }
        });
    }

    setupEventListeners() {
        // Listen for cart changes from anywhere in the site
        document.addEventListener('cart:updated', (event) => {
            if (event.detail && typeof event.detail.cartCount !== 'undefined') {
                this.updateCartElements(event.detail.cartCount);
            } else {
                this.initializeCartCount(); // Fallback to fetch if count not provided
            }
        });

        // Handle Shopify section loads (for theme editor and hot reloads)
        document.addEventListener('shopify:section:load', () => {
            setTimeout(() => {
                this.initializeCartCount();
            }, 100);
        });
    }
}

// Initialize the cart count handler when the DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.cartCountHandler = new CartCountHandler();
    });
} else {
    window.cartCountHandler = new CartCountHandler();
} 
